export interface IPriceSummaryTotal {
    subtotal: number;
    freight: number;
    tax: number;
    total: number;
}

export class PriceSummaryTotals {

    public subtotal: number = 0.0;

    public freight: number = 0.0;

    public tax: number = 0.0;

    public total: number = 0.0;

}